import React, { useEffect, useState } from "react";
import LiveIcon from "../../../../../../assets/images/Souvenir/live.png";
import axios from "axios";
import AuctionNav from "./AuctionNav/AuctionNav";
import LoaderPost from "../../../../../Reuseable/LoaderPost";
import ProductCard from "./Content/ProductCard";

const RejectedProductList = () => {
  const [rejectedProduct, setRejectedProduct] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    axios.get(`/api/admin/rejected/auction/product`).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        setRejectedProduct(res.data.rejectedProduct);
      }
    });
  }, []);

  return (
    <>
      <div className="AS">
        <AuctionNav />

        <div className="d-flex mb-4  head-line p-3">
          <div className=" d-flex">
            <img src={LiveIcon} className=" SouvenirIcon" alt="" />
          </div>
          <div className=" d-flex text-light fw-bold mt-1 mx-3 ">
            Rejected Product
          </div>
        </div>

        {loading ? (
          <LoaderPost />
        ) : (
          <ProductCard data={rejectedProduct} noBidder="true" />
        )}
      </div>
    </>
  );
};

export default RejectedProductList;
